const MigrationPackageIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M10 18.334V10.0002M10 10.0002L2.7417 5.83331M10 10.0002L17.2584 5.83331M6.25 3.55779L13.75 7.8497M9.16667 18.1089C9.42003 18.2552 9.70744 18.3322 10 18.3322C10.2926 18.3322 10.58 18.2552 10.8333 18.1089L16.6667 14.7754C16.9198 14.6293 17.13 14.4191 17.2763 14.1661C17.4225 13.913 17.4997 13.6259 17.5 13.3337V6.66661C17.4997 6.37432 17.4225 6.08725 17.2763 5.8342C17.13 5.58114 16.9198 5.371 16.6667 5.22486L10.8333 1.89133C10.58 1.74504 10.2926 1.66803 10 1.66803C9.70744 1.66803 9.42003 1.74504 9.16667 1.89133L3.33333 5.22486C3.08022 5.371 2.86998 5.58114 2.72372 5.8342C2.57745 6.08725 2.5003 6.37432 2.5 6.66661V13.3337C2.5003 13.6259 2.57745 13.913 2.72372 14.1661C2.86998 14.4191 3.08022 14.6293 3.33333 14.7754L9.16667 18.1089Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default MigrationPackageIcon;
